import React, { useContext, useEffect, useState, useMemo } from 'react'
import { DistributionContext } from '.';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import SendBox from './sendBoxStep2';
import BoxInfo from './boxInfo';
import Typography from '@mui/material/Typography';
import DispbksBox from './disbksBox';

const Step2 = () => {

    const { state, setState } = useContext(DistributionContext)
    const [datagrid1, setDatagrid1] = useState({})
    const [datagrid2, setDatagrid2] = useState({})


    const getStep2ColumnsA = () => {
        const columns = []

        columns.push({

            field: 'aro',
            headerName: 'Aro',
            flex: 0.7,
            cellClassName: () => {
                return clsx('default-app bold', {
                    selected: true,
                });
            }
        })

        columns.push({

            field: 'medida',
            headerName: 'Medida',
            flex: 0.9,
            cellClassName: () => {
                return clsx('default-app bold align-start', {
                    selected: true,
                });
            }
        })


        for (let i = 0; i < state.columns.length; i++) {
            const column = state.columns[i];


            let includeColumn = true;

            // Só aplica a soma se já houver rows
            if (state.distrA.length > 0) {
                const total = state.distrA.reduce((acc, row) => {
                    const value = row[column];
                    return acc + (typeof value === 'number' ? value : 0);
                }, 0);

                includeColumn = total > 0;
            }

            if (includeColumn) {

                const isVenda = column.includes("Ven");

                columns.push({
                    field: column,
                    headerName: column,
                    flex: 0.5,
                    cellClassName: (params) => {
                        if (isVenda) {
                            // Configuração para VENDA
                            if (params.field === state.selectedFilialVen) {
                                return clsx('super-app ven-tables', { selected: true });
                            } else {
                                return clsx('default-app ven-tables', { selected: true });
                            }
                        } else {
                            // Configuração para ESTOQUE
                            if (params.field === state.selectedFilial) {
                                return clsx('super-app est-tables', { selected: true });
                            } else {
                                return clsx('default-app est-tables', { selected: true });
                            }
                        }
                    },
                });
            }

        }

        columns.push({
            field: 'dispbks',
            headerName: 'BKS Disp',
            flex: 1,
            renderCell: ({ value, row }) => (
                <Box className='default-app dep-bks' sx={{ padding: '0px 50px' }}>

                    <DispbksBox bks={value} cargo={row.cargo} state={state} lock={0} />
                </Box>
            )

        })


        columns.push({
            field: state.reservBranch,
            headerName: state.reservBranchName,
            flex: 1,
            cellClassName: () => {
                return clsx('default-app reserv', {
                    selected: true,
                });
            }
        })

        columns.push({
            field: 'cargo',
            headerName: 'Carga',
            flex: 1,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true,
                });
            },
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <SendBox aro={params.row.aro} med={params.row.medida} envio={params.row.cargo} type={params.row.type}
                        cargo={params.row} calculateTotal={calculateTotal}
                    />
                </Box>
            )
        })

        return columns

    }

    const getStep2ColumnsB = () => {
        const columns = []

        columns.push({

            field: 'aro',
            headerName: 'Aro',
            flex: 0.7,
            cellClassName: () => {
                return clsx('default-app bold', {
                    selected: true,
                });
            }
        })

        columns.push({

            field: 'medida',
            headerName: 'Medida',
            flex: 0.9,
            cellClassName: () => {
                return clsx('default-app bold align-start', {
                    selected: true,
                });
            }
        })


        for (let i = 0; i < state.columns.length; i++) {
            const column = state.columns[i];


            let includeColumn = true;

            // Só aplica a soma se já houver rows
            if (state.distrB.length > 0) {
                const total = state.distrB.reduce((acc, row) => {
                    const value = row[column];
                    return acc + (typeof value === 'number' ? value : 0);
                }, 0);

                includeColumn = total > 0;
            }

            if (includeColumn) {

                const isVenda = column.includes("Ven");

                columns.push({
                    field: column,
                    headerName: column,
                    flex: 0.5,
                    cellClassName: (params) => {
                        if (isVenda) {
                            // Configuração para VENDA
                            if (params.field === state.selectedFilialVen) {
                                return clsx('super-app ven-tables', { selected: true });
                            } else {
                                return clsx('default-app ven-tables', { selected: true });
                            }
                        } else {
                            // Configuração para ESTOQUE
                            if (params.field === state.selectedFilial) {
                                return clsx('super-app est-tables', { selected: true });
                            } else {
                                return clsx('default-app est-tables', { selected: true });
                            }
                        }
                    },
                });
            }

        }



        columns.push({
            field: 'dispbks',
            headerName: 'BKS Disp',
            flex: 1,
            renderCell: ({ value, row }) => (
                <Box className='default-app dep-bks' sx={{ padding: '0px 50px' }}>

                    <DispbksBox bks={value} cargo={row.cargo} state={state} lock={0} />
                </Box>
            )
        })


        columns.push({
            field: state.reservBranch,
            headerName: state.reservBranchName,
            flex: 1,
            cellClassName: () => {
                return clsx('default-app reserv', {
                    selected: true,
                });
            }
        })

        columns.push({
            field: 'cargo',
            headerName: 'Carga',
            flex: 1,
            cellClassName: () => {
                return clsx('default-app', {
                    selected: true,
                });
            },
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <SendBox aro={params.row.aro} med={params.row.medida} envio={params.row.cargo} type={params.row.type}
                        cargo={params.row} calculateTotal={calculateTotal}
                    />
                </Box>
            )
        })

        return columns

    }





    const calculateTotal = () => {
        const totalA = state.distrA.reduce((sum, obj) => sum + (obj?.cargo || 0), 0);
        const totalB = state.distrB.reduce((sum, obj) => sum + (obj?.cargo || 0), 0);
        const totalAB = totalA + totalB

        setState({ totalAB: totalAB })
    }

    const changeDatagrid1 = (params) => {
        setDatagrid1(params)
        const stringColumn = JSON.stringify(params)
        localStorage.setItem('datagrid-step2-1', stringColumn);
    };

    const changeDatagrid2 = (params) => {
        setDatagrid2(params)
        const stringColumn = JSON.stringify(params)
        localStorage.setItem('datagrid-step2-2', stringColumn);
    };

    useEffect(() => {

        const datagrid1 = localStorage.getItem('datagrid-step2-1');
        if (datagrid1) {
            setDatagrid1(JSON.parse(datagrid1));
        }

        const datagrid2 = localStorage.getItem('datagrid-step2-2');
        if (datagrid2) {
            setDatagrid2(JSON.parse(datagrid2));
        }
    }, [])

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    <BoxInfo title={'TOTAL DE PNEUS'} value={state.totalAB} colorBack={'#c60000'} color={'white'} />

                    <Typography variant="h6" sx={{ color: '#c60000' }}>Itens que necessitam de maior atenção</Typography>
                </Box>

                <Box sx={{ width: '100%' }} >

                    <br />
                    <DataGrid
                        rowHeight={state.rowHeight}
                        className='alterned_grid'
                        density='compact'
                        rows={state.distrA}

                        columns={useMemo(() => getStep2ColumnsA())}
                        columnVisibilityModel={datagrid1}
                        onColumnVisibilityModelChange={(newModel) =>
                            changeDatagrid1(newModel)
                        }
                        sx={{
                            '& .super-app.selected': {
                                fontWeight: '600',
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            '& .default-app.selected': {
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            maxHeight: "30rem",
                            '& .MuiDataGrid-columnHeaderTitleContainer': {
                                justifyContent: 'center',
                            },

                        }}

                    />
                </Box>


                <Box>
                    <br /><br />
                    <Typography variant="h6" sx={{ color: '#c60000' }}>Itens calculados automaticamente</Typography>
                </Box>

                <Box sx={{ width: '100%' }} >
                    <br />
                    <DataGrid
                        rowHeight={state.rowHeight}
                        className='alterned_grid'
                        density='compact'
                        rows={state.distrB}
                        columns={useMemo(() => getStep2ColumnsB())}
                        columnVisibilityModel={datagrid2}
                        onColumnVisibilityModelChange={(newModel) =>
                            changeDatagrid2(newModel)
                        }
                        sx={{
                            '& .super-app.selected': {
                                fontWeight: '600',
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            '& .default-app.selected': {
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            maxHeight: "20rem",
                            '& .MuiDataGrid-columnHeaderTitleContainer': {
                                justifyContent: 'center',
                            },
                        }}

                    />
                </Box>

            </Box>

        </>
    )
}

export default Step2;